import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const Clock: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M8.17 2.76a10 10 0 0 1 7.66 18.48A10 10 0 1 1 8.17 2.76ZM12 4a8 8 0 1 0 8 8 8 8 0 0 0-8-8Zm0 2a1 1 0 0 1 1 1v4h2.5a1 1 0 0 1 0 2H12a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Z" />
  </Icon>
);

export default Clock;
